module.exports = __webpack_public_path__ + "media/images/ana_triste-faec3681f316435a112bb8cfa6cff95d.png";